const formatAddress = ({ address = {}, verbose = false, formatMessage }) => (
    verbose
        ? {
            streetDetails: [address.street, address.streetNumber, address.entrance].filter(Boolean).join(' '),
            cityDetails: [address.zip, address.city].filter(Boolean).join(' '),
            floorDetails: [
                address.floor ? formatMessage('manageDeliveries.addressFormatter.floor', { floor: address.floor }) : '',
                address.flat ? formatMessage(
                    'manageDeliveries.addressFormatter.flat', { flat: address.flat }
                ) : '',
            ].filter(Boolean).join(', '),
            coDetails: address.co ? `${formatMessage('manageDeliveries.addressFormatter.co')} ${address.co}` : '',
        }
        : [
            [address.street, address.streetNumber, address.entrance].filter(Boolean).join(' '),
            address.zip,
            address.city,
        ].filter(Boolean).join(', ')
);

export default formatAddress;
